// Global packages and components
import { Marquee } from '@devnomic/marquee'

// @NOTE: We don't import the CSS as instructed as it breaks other site styling. If there are custom styles missing
// when trying to apply marquee settings, look at the plugin and add them to our local /styles/custom.css
// @REF: https://github.com/devnomic/marquee/issues/4

// Types
import type { ReactNode } from 'react'

interface SiteMessageProps {
  children?: ReactNode
}

// Main export
const SiteMessage = ({ children }: SiteMessageProps) => (
  <div className="bg-emerald-green p-2 text-center text-xs text-white">
    <div className="marquee-wrapper container">
      <Marquee
        fade={true}
        className="gap-[3rem] [--duration:15s]"
        innerClassName="gap-[3rem] [--gap:3rem] marquee-wrapper__item"
        numberOfCopies={5}
        pauseOnHover={true}
      >
        {children}
      </Marquee>
    </div>
  </div>
)

export default SiteMessage
